export const TRANSITION_PROGRAM_ACCEPT = 'accept';
export const TRANSITION_PROGRAM_MARK_AS_DRAFT = 'mark-as-draft';
export const TRANSITION_PROGRAM_MARK_AS_READY = 'mark-as-ready';
export const TRANSITION_PROGRAM_ACTIVATE = 'activate';
export const TRANSITION_PROGRAM_ACTIVATE_SEND_NOTIFICATION = 'activate-send-notification';
export const TRANSITION_PROGRAM_PUT_ON_HOLD = 'put-on-hold';
export const TRANSITION_PROGRAM_REACTIVATE = 'reactivate';
export const TRANSITION_PROGRAM_CANCEL = 'cancel';
export const TRANSITION_PROGRAM_INACTIVE_NOTE = 'inactive-note';
export const TRANSITION_PROGRAM_IS_CANCELED = 'is-canceled';

export const TRANSITION_PROGRAM = {
  TRANSITION_PROGRAM_ACCEPT,
  TRANSITION_PROGRAM_MARK_AS_READY,
  TRANSITION_PROGRAM_MARK_AS_DRAFT,
  TRANSITION_PROGRAM_ACTIVATE,
  TRANSITION_PROGRAM_ACTIVATE_SEND_NOTIFICATION,
  TRANSITION_PROGRAM_PUT_ON_HOLD,
  TRANSITION_PROGRAM_REACTIVATE,
  TRANSITION_PROGRAM_CANCEL,
  TRANSITION_PROGRAM_INACTIVE_NOTE,
  TRANSITION_PROGRAM_IS_CANCELED,
};



// WEBPACK FOOTER //
// ./src/state-machine/program/transition-program.js